import { useMemo, useState } from "react";
import { sertifikatPekerja, adaSertifikatKritis, labelSertifikat } from "@/lib/sertifikat";
import { hitungUsia } from "@/lib/dates";

export const USIA_RANGES = [
  { key: "<30", label: "< 30 tahun", min: 0, max: 29 },
  { key: "30-39", label: "30 – 39 tahun", min: 30, max: 39 },
  { key: "40-49", label: "40 – 49 tahun", min: 40, max: 49 },
  { key: "50-54", label: "50 – 54 tahun", min: 50, max: 54 },
  { key: ">=55", label: "≥ 55 tahun", min: 55, max: 200 },
];

export const usiaPekerja = (w) => hitungUsia(w.tanggal_lahir) ?? (w.usia != null && w.usia !== "" ? Number(w.usia) : null);

export const masaKerjaTahun = (w) => {
  if (!w.tanggal_masuk) return null;
  const s = new Date(w.tanggal_masuk);
  if (isNaN(s)) return null;
  const n = new Date();
  let bulan = (n.getFullYear() - s.getFullYear()) * 12 + (n.getMonth() - s.getMonth());
  if (n.getDate() < s.getDate()) bulan--;
  return bulan < 0 ? null : Math.floor(bulan / 12);
};

const DEFAULT = { search: "", lokasi: [], jabatan: "all", level: "all", status: "AKTIF", sertifikat: "all", pertalife: "all", usia: "all", masaKerja: "all" };

const matchSertifikat = (w, f) => {
  if (f === "all") return true;
  const serts = sertifikatPekerja(w);
  if (f === "ada") return serts.length > 0 || !!w.punya_sertifikasi;
  if (f === "tidak") return serts.length === 0 && !w.punya_sertifikasi;
  if (f === "kritis") return adaSertifikatKritis(w);
  return serts.some((d) => labelSertifikat(d) === f);
};

const matchUsia = (w, f, usiaPensiun) => {
  if (f === "all") return true;
  const usia = usiaPekerja(w);
  if (usia == null) return f === "kosong";
  if (f === "kosong") return false;
  if (f === "pensiun") return usiaPensiun ? usia >= usiaPensiun : false;
  const r = USIA_RANGES.find((x) => x.key === f);
  return r ? usia >= r.min && usia <= r.max : true;
};

const matchMasaKerja = (w, f) => {
  if (f === "all") return true;
  const mk = masaKerjaTahun(w);
  if (mk == null) return f === "kosong";
  return f !== "kosong" && mk === Number(f);
};

const matchWorker = (w, f, usiaPensiun) => {
  const q = f.search.toLowerCase();
  return [w.nama, w.nomor_pegawai, w.jabatan, w.lokasi_kerja].some((v) => (v || "").toLowerCase().includes(q))
    && (f.lokasi.length === 0 || f.lokasi.includes(w.lokasi_kerja))
    && (f.jabatan === "all" || w.jabatan === f.jabatan)
    && (f.level === "all" || (w.level_pekerja || "").toUpperCase() === f.level)
    && (f.status === "all" || (w.status || "").trim().toUpperCase() === f.status)
    && matchSertifikat(w, f.sertifikat)
    && (f.pertalife === "all" || (f.pertalife === "ada") === !!(w.nomor_pertalife || "").trim())
    && matchUsia(w, f.usia, usiaPensiun)
    && matchMasaKerja(w, f.masaKerja);
};

// State + hasil filter Data Pekerja (satu objek state, satu useMemo)
export function useWorkerFilters(workers, usiaPensiun) {
  const [f, setF] = useState(DEFAULT);
  const set = (key) => (val) => setF((s) => ({ ...s, [key]: val }));
  const filtered = useMemo(() => (workers || []).filter((w) => matchWorker(w, f, usiaPensiun)), [workers, f, usiaPensiun]);
  const hasFilters = Object.keys(DEFAULT).some((k) => JSON.stringify(f[k]) !== JSON.stringify(DEFAULT[k]));
  return { f, set, setF, filtered, hasFilters, reset: () => setF(DEFAULT) };
}
